import React, {Component} from 'react'
import {Confirm} from "semantic-ui-react";


export class DawidConfirm extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const open = this.props.open;
        const content = this.props.content || "Are you sure you want to restart the survey? " +
            "All progress that has not been saved will be lost.";
        const confirmText = this.props.confirmText || "Reset";
        const cancelText = this.props.cancelText || "I changed my mind, don't reset";
        return (
            <div>
                <Confirm id="confirmReset" content={content}
                         open={open}
                         onCancel={this.props.onCancel}
                         onConfirm={this.props.onConfirm}
                         confirmButton={confirmText}
                         cancelButton={cancelText}
                />
            </div>
        )
    }
}